import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer class="footer footer-bg pt-8 pb-3">
        <div class="container">
          <div class="row gy-6 gy-xl-0 pb-4">
            <div class="col-xl-5 col-lg-12 col-md-6 col-12">
              <div class="d-flex flex-column gap-3 pe-5">
                <h1 className="display-6 fw-bold ls-sm lh-1">
                  <span className="text-white fw-light">
                    Swinglearn Network LLP
                  </span>
                </h1>
                <div className="mt-n5">
                  <img
                    src="/assets/images/line-shap.webp"
                    width="230"
                    className="mt-2"
                  />
                </div>
                <p class="mb-0 lh-sm text-white">
                  Swinglearn Network LLP is a fintech education platform based
                  in Prayagraj, Uttar Pradesh, dedicated to providing
                  job-oriented stock market education.
                  <br />
                  <br />
                  NSE Registered [AP2486037784] Under Choice Equity Broking
                  <br />
                  SEBI & Exchange Compliant, No Investment Advice, Market Risks
                  Apply
                </p>
              </div>
            </div>
            <div class="col-xl-2 col-md-3 col-6">
              <div class="d-flex flex-column gap-3">
                <span class="text-white-stable fw-medium text-light">
                  Community
                </span>
                <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                  <li>
                    <Link to="/terms" class="nav-link">
                      Terms & Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy" class="nav-link">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/payment" class="nav-link">
                      Payment Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-2 col-md-3 col-12">
              <div class="d-flex flex-column gap-3">
                <span class="text-white-stable fw-medium text-light">
                  Company
                </span>
                <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                  <li>
                    <Link to="/about" class="nav-link">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" class="nav-link">
                      Contact SLN
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-12">
              <div class="d-flex flex-column gap-5">
                <div class="d-flex flex-column gap-3">
                  <span class="text-white-stable fw-medium text-light">
                    Contact SLN
                  </span>
                  <ul class="list-unstyled mb-0 d-flex flex-column nav nav-footer nav-x-0">
                    <li className="mb-1">
                      Phone No: <span class="fw-normal">+91 63861 91243</span>
                    </li>
                    <li className="mb-1">
                      Email: <span class="fw-normal">info@slnacademy.com</span>
                    </li>
                    <li className="lh-sm mb-1">
                      Address:{" "}
                      <span class="fw-normal">
                        52, Dindayal Ka Pura, Ahirara, Bharwari (Kaushambi),
                        Manjhanpur, Uttar Pradesh &mdash; 212201, India
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mb-5">
          <h4 className="text-white lh-sm mb-0 fw-normal">
            1. NSE Authorised Person Registration{" "}
          </h4>
          <p className="text-white mb-2">
            SWINGLEARN NETWORK LLP is officially registered as an NSE Authorised
            Person (AP) under Choice Equity Broking Pvt. Ltd.{" "}
          </p>
          <ul className="text-white lh-sm">
            <li>AP Registration Code: AP2486037784</li>
            <li>Exchange: National Stock Exchange of India (NSE)</li>
            <li>Segments Approved: Cash Market (CM), Futures & Options (FO)</li>
            <li>Approval Date: 19-Nov-2025</li>
            <li>Regulatory Body: SEBI </li>
          </ul>

          <h4 className="text-white lh-sm mb-0 pt-2 fw-normal">
            2. SEBI & NSE Compliance
          </h4>
          <p className="text-white mb-2">
            We strictly follow all guidelines issued by:
          </p>
          <ul className="text-white mb-3 lh-sm">
            <li>
              <li>SEBI (Securities & Exchange Board of India)</li>
              <li>NSE (National Stock Exchange of India)</li>
              <li>
                Choice Equity Broking Pvt. Ltd. (Authorised Person Principal
                Broker)
              </li>
            </li>
          </ul>
        </div>

        <div class="border-top border-light">
          <div className="container pt-3">
            <div class="row">
              <div class="col-lg-6 col-12 text-center text-md-start">
                <span className="fw-normal m-0 text-light lh-sm">
                  © 2025 SLN Academy, Operated by Swinglearn Network LLP
                </span>
              </div>
              <div class="col-12 col-lg-6 d-lg-block d-none">
                <nav class="nav nav-footer justify-content-center justify-content-md-start justify-content-lg-end">
                  <Link to="/terms" class="nav-link active text-light">
                    Terms of Use
                  </Link>
                  <Link to="/privacy" class="nav-link text-light">
                    Privacy Policy
                  </Link>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
